<template>
  <OptionSummary></OptionSummary>
  <section class="section-weblog">
    <h1>وبلاگ</h1>
    <p>مطلبی درج نشده است</p>
  </section>
</template>

<script>
import OptionSummary from "@/components/OptionSummary/index.vue";
export default {
  name: "weblogPage",
  components: {
    OptionSummary,
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/weblog/weblog.css);
</style>